var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgTag2 = function SvgTag2(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.58593 17.0711L6.06381 13.549C5.11465 12.5998 4.64008 12.1252 4.34942 11.5423C4.26626 11.3756 4.19485 11.2032 4.13572 11.0264C3.92908 10.4087 3.92908 9.73758 3.92908 8.39527C3.92908 6.08197 3.92908 4.92532 4.53301 4.12373C4.70143 3.90018 4.90031 3.70131 5.12385 3.53288C5.92544 2.92896 7.08209 2.92896 9.39539 2.92896H9.3954C10.7377 2.92896 11.4089 2.92896 12.0265 3.1356C12.2033 3.19473 12.3757 3.26614 12.5425 3.3493C13.1254 3.63996 13.5999 4.11453 14.5491 5.06368L18.0712 8.58581C20.0712 10.5858 21.0712 11.5858 21.0712 12.8285C21.0712 14.0711 20.0712 15.0711 18.0712 17.0711C16.0712 19.0711 15.0712 20.0711 13.8286 20.0711C12.5859 20.0711 11.5859 19.0711 9.58593 17.0711ZM10.2929 11.2932C11.3975 11.2932 12.2929 10.3978 12.2929 9.29324C12.2929 8.18867 11.3975 7.29324 10.2929 7.29324C9.18831 7.29324 8.29288 8.18867 8.29288 9.29324C8.29288 10.3978 9.18831 11.2932 10.2929 11.2932Z",
    fill: "#22282F"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgTag2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Tag - 2.ead745680a3ab11a2c1c5a6de746b7b9.svg";